import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios'

// Haetaan tallennettu kieli localStoragesta tai käytetään oletuksena suomea
const getSavedLanguage = () => {
  try {
    return localStorage.getItem('language') || 'fi'
  } catch {
    return 'fi'
  }
}

// Haetaan tallennettu sivun leveys localStoragesta tai käytetään oletuksena normaalia
const getSavedLayoutWidth = () => {
  try {
    const savedWidth = localStorage.getItem('layoutWidth')
    if (savedWidth === 'wide' || savedWidth === 'full') {
      return savedWidth
    }
    return 'normal'
  } catch {
    return 'normal'
  }
}

const userSlice = createSlice({
  name: 'user',
  initialState: {
    language: getSavedLanguage(),
    layoutWidth: getSavedLayoutWidth(),
    _loaded: false,
  },
  reducers: {
    changeUser(state, action) {
      // Säilytetään kielivalinta kun käyttäjä muuttuu
      const language = state?.language || getSavedLanguage()
      const layoutWidth = state?.layoutWidth || getSavedLayoutWidth()
      if (action.payload === null) {
        return { language, layoutWidth, _loaded: false }
      }
      return { ...action.payload, language, layoutWidth, _loaded: true }
    },
    setActiveNationalTeam(state, action) {
      if (state) {
        return { ...state, activeNationalTeam: action.payload }
      }
      return state
    },
    setStaffData(state, action) {
      if (state) {
        return { ...state, staff: action.payload }
      }
      return state
    },
    setLanguage(state, action) {
      try {
        localStorage.setItem('language', action.payload)
      } catch {
        // Ignore localStorage errors
      }
      if (state) {
        return { ...state, language: action.payload }
      }
      return { language: action.payload }
    },
    setLayoutWidth(state, action) {
      const nextWidth =
        action.payload === 'wide' || action.payload === 'full'
          ? action.payload
          : 'normal'
      try {
        localStorage.setItem('layoutWidth', nextWidth)
      } catch {
        // Ignore localStorage errors
      }
      if (state) {
        return { ...state, layoutWidth: nextWidth }
      }
      return { layoutWidth: nextWidth }
    },
  },
})

export const {
  changeUser,
  setActiveNationalTeam,
  setStaffData,
  setLanguage,
  setLayoutWidth,
} = userSlice.actions

/**
 * Alustaa käyttäjän tiedot Reduxiin.
 * Jos käyttäjä on jo ladattu (_loaded), ei haeta uudelleen.
 * Jos ei, haetaan backendistä localStoragen tokenilla.
 */
export const initializeUser = () => {
  return async (dispatch, getState) => {
    const { user } = getState()
    // Jos käyttäjä on jo ladattu Reduxiin, ei haeta uudelleen
    if (user && user._loaded) {
      return user
    }
    const loggedUser = window.localStorage.getItem('loggedUser')
    if (loggedUser) {
      try {
        const response = await axios.get(`/users/${JSON.parse(loggedUser)}`)
        dispatch(changeUser(response.data))
        return response.data
      } catch (error) {
        console.error('Error initializing user:', error)
      }
    }
    return null
  }
}

export default userSlice.reducer
